module.exports = __webpack_public_path__ + "img/PD1506440644363681792.95778577.png";